import ProdigyTypeahead from './ProdigyTypeahead';

export default ProdigyTypeahead;
